import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

export default function InsightCard({
  title,
  children,
  span = 1,
  className,
  id,
  'data-testid': testId,
}) {
  const spanClass = span === 2 ? 'insight-span-2' : '';

  return (
    <Box
      id={id}
      data-testid={testId}
      className={`insight-card-wrapper ${spanClass} ${className || ''}`}
    >
      <Paper elevation={0} className="insight-card" style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        <Box className="insight-card-header" style={{ marginBottom: 16 }}>
          <Typography variant="h6" className="card-title" style={{ fontSize: '14px', fontWeight: 600 }}>
            {title}
          </Typography>
        </Box>
        <Box className="insight-card-content" style={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
          {children}
        </Box>
      </Paper>
    </Box>
  );
}
